import React from 'react';
import { Link as RouterLink, Outlet, useNavigate } from 'react-router-dom';
import {
  AppBar,
  Box,
  Button,
  Container,
  Link,
  Toolbar,
  Typography,
} from '@mui/material';

export default function AppShell() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    navigate('/login', { replace: true });
  };

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f6f7fb' }}>
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box>
            <Typography variant="h6">Incooking Growth Hub</Typography>
            <Typography variant="caption" color="text.secondary">
              Social marketing workspace
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button component={RouterLink} to="/accounts" color="inherit">
              Accounts
            </Button>
            <Button component={RouterLink} to="/connect-meta" color="inherit">
              Connect Meta
            </Button>
            <Button component={RouterLink} to="/settings" color="inherit">
              Settings
            </Button>
            <Button variant="outlined" color="primary" onClick={handleLogout}>
              Logout
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Outlet />
      </Container>

      <Box sx={{ borderTop: '1px solid #e0e0e0', py: 2, mt: 4 }}>
        <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="body2" color="text.secondary">
            © 2026 Incooking Growth Hub
          </Typography>
          <Link component={RouterLink} to="/privacy-policy" underline="hover">
            Privacy Policy
          </Link>
        </Container>
      </Box>
    </Box>
  );
}
